export default __webpack_public_path__ + "static/media/GoL-ClearGlass-Logo.7c5bceda.png";